"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ADVENTURE_SCRIPT_RESERVED_NAMES = void 0;
/**
 * Engine-injected script API names that adventure `## Scripts` must not declare.
 * Enforced in Phase 2 execution validation; exported here for load-time checks when wired.
 */
exports.ADVENTURE_SCRIPT_RESERVED_NAMES = new Set([
    'hasItem',
    'hasStat',
    'hasVisited',
    'isPlayer',
    'getVariable',
    'setVariable',
    'setSharedVariable',
    'setSharedVariableForUser',
    'createGuestAdventure',
    'getLastGuestAdventureInvite',
    'deleteGuestAdventureInvite',
    'addToVariable',
    'addToVariableForCharacter',
    'showToastForCharacter',
    'setVariableForCharacter',
    'addItem',
    'removeItem',
    'addStat',
    'removeStat',
    'currentScene',
    'currentLocation',
    'characterName',
    'inventory',
    'stats',
    'sceneHistory',
    'activityCompleted',
    'activityInProgress',
    'activityAvailable',
    'startActivity',
    'completeActivity',
    'currentEntity',
    'entityExists',
    'getEntityType',
    'getEntityParent',
    'getEntityDisplayName',
    'createEntity',
    'destroyEntity',
    'setCurrentEntity',
    'clearCurrentEntity',
    'getEntityVariable',
    'setEntityVariable',
    'getPlayerCharacter',
    'getPartnerName',
    'peekStack',
    'pushStack',
    'popStack',
    'setCharacterMapValue',
    'clearCharacterMapValue',
    'resetCharacterMap',
    'getCharacterMapValue',
    'getCharacterMap',
    'eval',
    'require',
    'import',
    'export',
    'global',
    'window',
    'document',
    'process',
    // Host-registered Collabajam CSM helpers (see scriptApiExtensions)
    'parseCsm',
    'formatCsmDiagnostic',
    'formatCsmDiagnostics',
    // Host-warmed join/picker bags and opening-stack parsers
    'generateJoinAdventureOptions',
    'generatePickerOptions',
    'generatePickerChildOptions',
    'getPickerChildCount',
    'getPickerDefaultChildId',
    'getPickerItem',
    'getPickerChild',
    'getHostFlag',
    'getHostEntityStatus',
    'getOpeningSessionId',
    'getOpeningAdventureId',
    'openingAdventureHasTag'
]);
//# sourceMappingURL=adventureScriptReservedNames.js.map